import * as React from 'react';
import { getTranslator, LanguageCode } from '../../Translator';

export class FilterList<T> extends React.Component
    <{
        items: T[],
        searchTerm: string,
        onChange: (newSearchTerm: string) => void,
        filter: (item: T, searchTerm: string) => boolean,
        render: (item: T) => JSX.Element,
        label: string,
        className?: string,
        placeholder?: string,
        language: LanguageCode,
        minItemCountForFilter?: number
    }> {

    render() {
        const t = getTranslator(this.props.language);

        const filteredItems = (this.props.searchTerm && this.props.searchTerm.length)
            ? this.props.items.filter(item => this.props.filter(item, this.props.searchTerm))
            : this.props.items;

        return <section>
            {(!this.props.minItemCountForFilter || this.props.items.length > this.props.minItemCountForFilter) &&
                <div className="search-wrapper" key={0}>
                    <input
                        type="text"
                        className="search-box"
                        placeholder={this.props.label}
                        aria-label={this.props.label}
                        onChange={({ target: { value } }) => this.props.onChange(value)}
                        value={this.props.searchTerm || ''} />
                    <div
                        aria-label={t['Clear search field']}
                        className="close-icon"
                        onClick={() => this.props.onChange('')}>
                        X
                    </div>
                </div>
            }

            <div className={this.props.className} key={1}>

                {filteredItems.length === 0
                    ? <p>{t['No results found']}</p>
                    : filteredItems.map(this.props.render)
                }
            </div>
        </section>;
    }
}
